"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseModal = exports.IBaseModalSize = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Fade_1 = tslib_1.__importDefault(require("@material-ui/core/Fade"));
var Backdrop_1 = tslib_1.__importDefault(require("@material-ui/core/Backdrop"));
var BaseModal_style_1 = require("./BaseModal.style");
var IBaseModalSize;
(function (IBaseModalSize) {
    IBaseModalSize["SMALL"] = "small";
    IBaseModalSize["MEDIUM"] = "medium";
})(IBaseModalSize = exports.IBaseModalSize || (exports.IBaseModalSize = {}));
exports.BaseModal = function (_a) {
    var opened = _a.opened, children = _a.children, onBackdropClick = _a.onBackdropClick, classes = _a.classes, _b = _a.size, size = _b === void 0 ? IBaseModalSize.MEDIUM : _b;
    var defaultClasses = BaseModal_style_1.useBaseModalStyles();
    var styles = classes
        ? tslib_1.__assign(tslib_1.__assign({}, defaultClasses), classes) : defaultClasses;
    var sizeClass = styles[size];
    var BACKDROP_TIMEOUT = 500;
    return (react_1.default.createElement(core_1.Modal, { "data-signa": "simple-modal-title", open: opened, onClose: function (opened) { return opened; }, disableBackdropClick: false, onBackdropClick: onBackdropClick, className: styles.root + " " + sizeClass, BackdropComponent: Backdrop_1.default, BackdropProps: {
            timeout: BACKDROP_TIMEOUT,
            classes: {
                root: styles.backDrop,
            },
        } },
        react_1.default.createElement(Fade_1.default, { in: opened },
            react_1.default.createElement(core_1.Paper, { classes: { root: styles.paper }, elevation: 1 }, children))));
};
